import React, { useState, useEffect, useCallback } from 'react';

import { i18n } from 'core/i18n';
import HireNewToolTip from './hireNewToolTip';
import { EURO_SYMBOL, PERCENTAGE_SYMBOL, CARD_PAYMENT_METHOD_UNIQUE, CARD_PAYMENT_METHOD_FIXED, CARD_PAYMENT_METHOD_VARIABLE, CARD_PAYMENT_METHOD_VARIABLE_INCREMENT_INTERVAL, CARD_PAYMENT_METHOD_VARIABLE_MIN_PERCENTAGE, CARD_PAYMENT_METHOD_VARIABLE_MAX_PERCENTAGE, CREDIT_CARD_REVOLVING_PROCESS, PRODUCTION_ENVIRONMENT, OCULTO_ENVIRONMENT } from 'constants/index';
import OKSelect from 'commonsComponents/OKSelect';
import HireNewPaymentSimulator from './hireNewPaymentSimulator';
import { formatAmount } from 'utilities/currencyHelper';
import { OKMessage } from 'commonsComponents/OKMessage';
import { OKCheckbox } from 'commonsComponents/OKCheckbox';
import { RadioButton } from 'commonsComponents/radioButton';
import { RadioButtonGroup } from 'commonsComponents/radioButtonGroup';
import { BoxTabs } from 'commonsComponents/boxTabs';
import { ContentBox } from 'commonsComponents/contentBox';
import { LoadingSection } from 'commonsComponents/loadingSection';
import { isPrintOfficeMode } from 'utilities/contactCenter/printerHelper';
import BlockInfo from 'components/contactCenter/blockInfo/blockInfo';


const { FormattedText, formatText, getLanguage } = i18n;

const HireNewPaymentMethod = ({
    handleTypeChange,
    isNerudaCard,
    setInneParams,
    immHirePaymentMethod,
    immHireCreditLimit,
    requestAfiInformation,
    handleValueChange,
    creditType,
    immGlobalVariables,
    revolvingPackId,
    setAFIParams,
    immPdfRevolvingPersistent,
    newSetCardLimit,
    newSetHireCreditCardType,
    setTooltipShown,
    getTinValue,
    getTaeValue,
    isCheckboxChecked,
    newOptions,
    paymentAmount,
    currentInstallments,
    agreeCheckboxCC,
    checkoOperationPaymentMethod,
    checkPaymentMehod,
    setCheckPaymentMehod
}) => {
    const [state, setState] = useState({
        afiUrl: '',
        isShowInfoCC: typeof immHirePaymentMethod.get('value') !== 'string',
        isShowBottomCC: typeof immHirePaymentMethod.get('value') !== 'string' || immHirePaymentMethod.get('type') === CARD_PAYMENT_METHOD_UNIQUE,
        tin: getTinValue(creditType),
        tae: getTaeValue(creditType, 'aplazado_tae'),
        taeInit: getTaeValue(creditType, 'tae')

    });
    const successType = immHirePaymentMethod.get('success')
    const [activeTab, setActiveTab] = useState(0);
    const [clickedButtons, setClickedButtons] = useState(new Set([0]));  
    const [allClicked, setAllClicked] = useState(true);  

    const [isThreeSimulationsChecked, setIsThreeSimulationsChecked] = useState(false);
    const CALCULATION_TYPE_FIXED_FEE = 0
    const CALCULATION_TYPE_VARIABLE_FEE = 1
    useEffect(() => {
        if (isNerudaCard) {
            !successType && handleTypeChange(CARD_PAYMENT_METHOD_UNIQUE);
        }

        const { tin, tae, taeInit } = state;
        setInneParams({ tin, tae, taeInit });
        checkRevolving();

    }, []);

    useEffect(() => {
        checkRevolving();
    }, [immHirePaymentMethod, activeTab]);



    const checkRevolving = useCallback(() => {
        const value = immHirePaymentMethod.get('value');
        const method = immHirePaymentMethod.get('type');
        const calculationType = getCalculationType(method);
        const isNumberPayment = typeof immHirePaymentMethod.get('value') !== 'string';
        const isTypeMethodUnique = immHirePaymentMethod.get('type') === CARD_PAYMENT_METHOD_UNIQUE;
        const increasedValue = value * 2;
        const valueToUse = (__CONTACT_CENTER__ && activeTab === 2) ? increasedValue : value;
        const afiUrl = buildAFISimulatorURL(calculationType, valueToUse);

        if (isNumberPayment && !isTypeMethodUnique) {
            const amount = immHireCreditLimit.get('creditLimit');
            setState(prevState => ({
                ...prevState,
                afiUrl: afiUrl
            }));
            requestAfiInformation(paymentAmount ? paymentAmount : amount);
        }

        setState(prevState => ({
            ...prevState,
            isShowInfoCC: isNumberPayment,
            isShowBottomCC: isNumberPayment || isTypeMethodUnique
        }));
    }, [immHirePaymentMethod, immHireCreditLimit, activeTab]);

    const handleDropdownChange = (valueObject) => {
        handleValueChange(valueObject.value);
        checkoOperationPaymentMethod ? setCheckPaymentMehod(false) : setIsThreeSimulationsChecked(false);

    };

    const generateSequence = (first, last, increment) => {
        let numbers = [];
        let number = first;
        numbers.push(number);
        while ((number + increment) <= last) {
            number += increment;
            numbers.push(number);
        }
        return numbers;
    };

    const generateDropdownOptions = (percentage = false) => {
        const creditLimit = immHireCreditLimit.get('creditLimit');
        let increment;
        if (percentage) {
            increment = CARD_PAYMENT_METHOD_VARIABLE_INCREMENT_INTERVAL;
        } else {
            increment = ['diamond', 'premium'].includes(creditType) ? 150 : 15;
        }

        const first = percentage ? CARD_PAYMENT_METHOD_VARIABLE_MIN_PERCENTAGE : Math.ceil((0.05 * creditLimit) / increment) * increment;
        const last = percentage ? CARD_PAYMENT_METHOD_VARIABLE_MAX_PERCENTAGE : Math.floor((0.9 * creditLimit) / increment) * increment;
        const sequence = generateSequence(first, last, increment);

        return sequence.map(item => ({
            value: item,
            label: `${formatAmount(item, getLanguage(), 0)} ${percentage ? PERCENTAGE_SYMBOL : EURO_SYMBOL}`
        }));
    };


    const buildDropdownElement = () => {
        const paymentMethodType = immHirePaymentMethod.get('type');
        const paymentMethodValue = immHirePaymentMethod.get('value');
        let dropdownElement;
        if (paymentMethodType !== CARD_PAYMENT_METHOD_UNIQUE) {
            let errorMsg;
            let label;
            let minPercentageText;
            let fixedFeeCcText;
            let variableFeeCcText;
            let options;
            const errorMsgVisible = immHirePaymentMethod.get('valueIsDirty') && !immHirePaymentMethod.get('valueIsValid');
            switch (paymentMethodType) {
                case CARD_PAYMENT_METHOD_FIXED:

                    label = formatText('hirePaymentMethodComponent-fixedFeeDropdownTitle');
                    options = generateDropdownOptions();
                    errorMsg = formatText('hirePaymentMethodComponent-fixedFeeErrorMsg');
                    fixedFeeCcText = (
                        <BlockInfo>
                            <p className="requiredReadingStrong">
                                <FormattedText value="cc_hireNewCreditCard-requiredReading" />
                            </p>
                            <FormattedText value="cc_hireNewCreditCard-step1InfoFixedFee" />
                        </BlockInfo>
                    );
                    break;
                case CARD_PAYMENT_METHOD_VARIABLE:
                    label = formatText('hirePaymentMethodComponent-variableFeeDropdownTitle')
                    options = generateDropdownOptions(true);
                    errorMsg = formatText('hirePaymentMethodComponent-variableFeeErrorMsg');
                    minPercentageText = (
                        <FormattedText
                            className="hire-payment-method__min-percentage-text"
                            injectedStrings={[CARD_PAYMENT_METHOD_VARIABLE_MIN_PERCENTAGE]}
                            value="hirePaymentMethodComponent-minPercentage"
                        />
                    );
                    variableFeeCcText = (
                        <BlockInfo>
                            <p className="requiredReadingStrong">
                                <FormattedText value="cc_hireNewCreditCard-requiredReading" />
                            </p>
                            <FormattedText value="cc_hireNewCreditCard-step1InfoVariableFee" />
                        </BlockInfo>
                    );
                    break;
            }

            dropdownElement = (
                <>
                    {__CONTACT_CENTER__ && !isPrintOfficeMode() && (
                        <div className="hire-payment-method-cc-text">
                            {paymentMethodType === CARD_PAYMENT_METHOD_FIXED && fixedFeeCcText}
                            {paymentMethodType === CARD_PAYMENT_METHOD_VARIABLE && variableFeeCcText}
                        </div>
                    )}
                    <div className="hire-payment-method__fee-input-cards">
                        <FormattedText
                            value="cardChangePaymentMethod-installments"
                            className="card-change-payment-method-step-one__titleFee"
                        />
                        <OKSelect
                            label={label}
                            searchable={true}
                            options={newOptions ? newOptions.toJS() : options}
                            onChange={handleDropdownChange}
                            value={paymentMethodValue}
                            errorState={errorMsgVisible}
                            errorMessage={errorMsg}
                        />
                        {minPercentageText}
                    </div>
                </>
            );
        }

        return dropdownElement;
    };


    const getCalculationType = (method) => {
        if (method === CARD_PAYMENT_METHOD_FIXED) {
            return CALCULATION_TYPE_FIXED_FEE;
        } else if (method === CARD_PAYMENT_METHOD_VARIABLE) {
            return CALCULATION_TYPE_VARIABLE_FEE;
        }
    };

    const buildAFISimulatorURL = (calculationType, value) => {
        const { tin } = state;
        const interestRate = Number(tin.replace('%', '').replace(',', '.')) / 100;
        const amount = immHireCreditLimit.get('creditLimit');
        const paymentValueParamName = calculationType === CALCULATION_TYPE_FIXED_FEE ? 'FixedPaymentAmount' : 'PercentagePaymentRate';
        const paymentValue = calculationType === CALCULATION_TYPE_VARIABLE_FEE ? value / 100 : value;
        const oneYearValue = calculationType === CALCULATION_TYPE_VARIABLE_FEE ? 0.8 : paymentAmount ? paymentAmount / 12 : amount / 12;
        let urlParams = `?interestRate=${interestRate}&Amount=${amount}&CalculationType=${calculationType}&${paymentValueParamName}=${(__CONTACT_CENTER__ && activeTab === 1) ? oneYearValue : paymentValue}`;;
        const language = getLanguage();
        if (language !== 'es') {
            urlParams += '&lang=en-US';
        }
        setAFIParams({
            interestRate,
            calculationType,
            calculatePaymentMethod: calculationType === undefined ? 'UNIQUE' : calculationType === 0 ? 'FIXED' : 'VARIABLE',
            typePayment: paymentValueParamName,
            valuePayment: (__CONTACT_CENTER__ && activeTab === 1) ? oneYearValue : paymentValue,
        });

        let url = formatText('hirePaymentMethodComponent-hirePaymentMethodComponent_AFISimulatorURLPRO');

        if (window.__ENV__ !== PRODUCTION_ENVIRONMENT && window.__ENV__ !== OCULTO_ENVIRONMENT) {
            url = formatText('hirePaymentMethodComponent-hirePaymentMethodComponent_AFISimulatorURLPRE');
        }

        return `${url}${urlParams}`;
    };


    const confirmationAgentLabel = <FormattedText value="cc_hireNewCreditCard-confirmationAgentLabelStep2" />



    const handleCheckboxChange = (event) => {
        const checked = event.target.checked;
        checkoOperationPaymentMethod ? setCheckPaymentMehod(checked) : setIsThreeSimulationsChecked(checked);
        agreeCheckboxCC(checked)
    };

    const onTabChange = (value) => {
         setActiveTab(value);
              setClickedButtons((prev) => {
                const updatedSet = new Set(prev);
                updatedSet.add(value);
    
                 if (updatedSet.size === 3) {
                    setAllClicked(false);
                }
    
                return updatedSet;
            });
    };
      const tabsNav = (
        <>
            <BoxTabs
                tabs={[
                    formatText('cc_hireNewCreditCard-simulatorAmortizeCustomerFee'),
                    formatText('cc_hireNewCreditCard-simulatorAmortizeInOneYear'),
                    formatText('cc_hireNewCreditCard-simulatorAmortizeByIncreasingOneHundredPercent')
                ]}
                activeTab={activeTab}
                handleSelectedTab={onTabChange}
                defaultTabIndex={0}
                tabsAsPills={true}
            />
        </>
    );


    const buildMessageError = () => {
        return (
            <OKMessage type="warning">
                <div className="hire-payment-method__error-title">
                    <FormattedText value="hirePaymentMethodComponent-hirePaymentMethodComponent_iframeErrorTitle" />
                </div>
                <div className="hire-payment-method__error-text">
                    <FormattedText value="hirePaymentMethodComponent-hirePaymentMethodComponent_iframeErrorContent" />
                </div>
                <div className="hire-payment-method__error-text">
                    <FormattedText value="hirePaymentMethodComponent-hirePaymentMethodComponent_iframeErrorFooter" />
                </div>
            </OKMessage>
        );
    };

    const buildSimulatorContent = () => {
        const value = currentInstallments ? currentInstallments : immHirePaymentMethod.get('value');
        const error = immPdfRevolvingPersistent.get('isIframeError');
        const success = immPdfRevolvingPersistent.get('isIframeSuccess');
        const loading = immPdfRevolvingPersistent.get('isIframeIsFetching');
        if (!!value) {
            if (loading && !success) {
                return (<LoadingSection />);
            } else if (success) {
                return (
                    __CONTACT_CENTER__ ? (
                        <>
                            <div className="col-md-12">
                                <BlockInfo>
                                    <p className="requiredReadingStrong">
                                        {isPrintOfficeMode()
                                            ? <FormattedText value="cc_hireNewCreditCard-requiredReadingOfcine" />
                                            : <FormattedText value="cc_hireNewCreditCard-requiredReading" />
                                        }
                                    </p>
                                    <FormattedText value="cc_hireNewCreditCard-hirePaymentSimulatorThreeOptions" />
                                </BlockInfo>
                                <ContentBox>
                                    <div className="row">
                                        <div className="hire-new-payment-simulator-loader col-md-11">
                                            {tabsNav}
                                        </div>
                                    </div>
                                </ContentBox>
                            </div>
                            <div className="new-payment-simulator-CC col-md-12">
                                <HireNewPaymentSimulator immPdfRevolvingPersistent={immPdfRevolvingPersistent} activeTab={activeTab} />
                                <div className="hire-new-payment-chekbox">
                                    <OKCheckbox
                                        idName="hireNewCreditCardThreeStepsRead"
                                        label={confirmationAgentLabel}
                                        onChange={handleCheckboxChange}
                                        value={checkoOperationPaymentMethod ? checkPaymentMehod : isThreeSimulationsChecked}
                                        disabled={allClicked}
                                    />
                                </div>
                            </div>
                        </>
                    ) : (
                        <div className="hire-payment-method__simulator-iframe">
                            <HireNewPaymentSimulator immPdfRevolvingPersistent={immPdfRevolvingPersistent} />
                        </div>
                    )
                );
            } else if (error) {
                return buildMessageError();
            }
        }
        return null;
    };

    const handleSelectTypeOnChange = (type) => {
        handleTypeChange(type);
        newSetCardLimit && newSetHireCreditCardType();
        checkoOperationPaymentMethod ? setCheckPaymentMehod(false) : setIsThreeSimulationsChecked(false);
        agreeCheckboxCC(false)
    };

    const buildRadioButtons = () => {
        const paymentMethodType = immHirePaymentMethod.get('type');
        const tooltipKeys = {
            'open-credit': 'deferredTooltip',
            'diamond': 'deferredTooltipDiamondPremium',
            'premium': 'deferredTooltipDiamondPremium',
            'revolving': 'deferredTooltipRevolving',
            'viat': 'deferredTooltipVIAT'
        };

        const tooltipKey = tooltipKeys[creditType];

        let radioButtonElements;
        let radioButtonContent;

        let radioButtonOptions = [
            {
                value: CARD_PAYMENT_METHOD_UNIQUE,
                label: 'hirePaymentMethodComponent-optionFullPay',
            },
            {
                label: 'hireNewCreditCard-optionDeferredFixedFee',
                showSimulator: true,
                tooltipContent: <FormattedText value={`hirePaymentMethodComponent-${tooltipKey}`} />,
                tooltipType: 'tooltipFixedPaymentShown',
                value: CARD_PAYMENT_METHOD_FIXED,
            },
            {
                label: 'hireNewCreditCard-optionDeferredVariableFee',
                showSimulator: true,
                tooltipType: 'tooltipVariablePaymentShown',
                value: CARD_PAYMENT_METHOD_VARIABLE,
            }

        ];

        const buildRadioButtonContent = (option, index) =>{
            const isChecked = paymentMethodType === option.value;
            let dropdownElement;
            let simulatorContent;
            let messageInfoContent = null;

            if (isChecked && (isNerudaCard || !isNerudaCard)) {
                dropdownElement = buildDropdownElement();


                if (option.showSimulator) {
                    simulatorContent = buildSimulatorContent();
                }
            }

            return (
                <div key={index}>
                    <div className="row">
                        <div className="col-xs-8 col-md-6">
                            {dropdownElement}
                        </div>
                    </div>
                    {messageInfoContent}
                    <div className="row">
                        {simulatorContent}
                    </div>
                </div>
            );
        };


        radioButtonElements = radioButtonOptions.map((option, index) => {
            const isChecked = paymentMethodType === option.value;
            let label = <FormattedText value={option.label} />;

            return (
                <div key={index}>
                    <RadioButton
                        className="block-step__radio"
                        id={`methodOfPayment${index}`}
                        isChecked={isChecked}
                        label={label}
                        onChange={handleSelectTypeOnChange}
                        value={option.value}
                        disabled={__CONTACT_CENTER__ && !isPrintOfficeMode() ? !isCheckboxChecked : undefined}
                    />
                    {(!__CONTACT_CENTER__ || (__CONTACT_CENTER__ && isPrintOfficeMode())) && buildRadioButtonContent(option, index)}
                </div>
            );
        });

        const radioButtonContentCC = radioButtonOptions.map((option, index) => {
            return buildRadioButtonContent(option, index);
        })

        
        return (<div>
                    {radioButtonElements}
                    {__CONTACT_CENTER__ && !isPrintOfficeMode() && radioButtonContentCC}
                </div>);
    };

    const radioButtonElements = buildRadioButtons();
    const typeErrorMsgVisible = immHirePaymentMethod.get('typeIsDirty') && !immHirePaymentMethod.get('typeIsValid');
    const typeErrorMsg = formatText('hirePaymentMethodComponent-typeErrorMsg');
    return (
        <>
            {!immHireCreditLimit.get('isFetching') &&
                <article className="hire-payment-method row">
                    <div className="col-xs-12">
                        <FormattedText
                            className="hire-payment-method__header-label"
                            value="hirePaymentMethodComponent-title"
                        />
                        <HireNewToolTip
                            state={state}
                            immGlobalVariables={immGlobalVariables}
                            revolvingPackId={revolvingPackId}
                            creditType={creditType}
                            setTooltipShown={setTooltipShown}
                        />
                        <RadioButtonGroup
                            name="selectMethodOfPayment"
                            idPrefix="selectMethodOfPayment"
                            errorState={typeErrorMsgVisible}
                            errorMessage={typeErrorMsg}
                        >
                            {radioButtonElements}
                        </RadioButtonGroup>
                    </div>
                </article>
            }


        </>
    )
}

HireNewPaymentMethod.defaultProps = {
    creditType: 'open-credit',
    isNerudaCard: false,
    showFullPay: true
}



export default HireNewPaymentMethod;
